// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
._v5641hrg{transition:opacity .2s ease}._152tv77o{inset-block-start:var(--ds-space-025,2px)}
._1bah1h6o{justify-content:center}
._1bsb7vkz{width:1pc}
._1bsbgktf{width:20px}
._1e021l7b{inset-inline-start:3px}
._1e0c116y{display:inline-flex}
._4cvr1h6o{align-items:center}
._4t3i7vkz{height:1pc}
._4t3igktf{height:20px}
._kqswstnw{position:absolute}
._rjxp1l7b{inset-inline-end:3px}
._tzy4idpf{opacity:0}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/toggle/dist/esm/icon-container.compiled.css"],"names":[],"mappings":";AACA,WAAW,2BAA2B,CAAC,WAAW,yCAAyC;AAC3F,WAAW,sBAAsB;AACjC,WAAW,SAAS;AACpB,WAAW,UAAU;AACrB,WAAW,sBAAsB;AACjC,WAAW,mBAAmB;AAC9B,WAAW,kBAAkB;AAC7B,WAAW,UAAU;AACrB,WAAW,WAAW;AACtB,WAAW,iBAAiB;AAC5B,WAAW,oBAAoB;AAC/B,WAAW,SAAS","sourcesContent":["\n._v5641hrg{transition:opacity .2s ease}._152tv77o{inset-block-start:var(--ds-space-025,2px)}\n._1bah1h6o{justify-content:center}\n._1bsb7vkz{width:1pc}\n._1bsbgktf{width:20px}\n._1e021l7b{inset-inline-start:3px}\n._1e0c116y{display:inline-flex}\n._4cvr1h6o{align-items:center}\n._4t3i7vkz{height:1pc}\n._4t3igktf{height:20px}\n._kqswstnw{position:absolute}\n._rjxp1l7b{inset-inline-end:3px}\n._tzy4idpf{opacity:0}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
